import React from "react";
import Loader from "../../Loader/LoaderSection";
import Paginate from "../../shared/Paginate";

const MyDonationPayments = props => {
    function displayTableData() {
        let paymentsData = [];

        if (
            Array.isArray(props.payments.data) &&
            props.payments.data.length > 0 &&
            props.loading === false
        ) {
            let paymentsData = [];
            paymentsData = props.payments.data;

            return paymentsData.map(function(payments, index) {
                return (
                    <tr className="odd" key={index}>
                        <td>Php {payments.amount}</td>
                        <td className="recepient_date_column">{payments.receipt_date}</td>
                        <td>{payments.payment_method ? payments.payment_method.payment_method : '--'}</td>
                        <td>{payments.receipt_url && <a href={payments.receipt_url} title="link to receipt" target="_blank">View receipt</a>}</td>
                    </tr>
                );
            });
        } else if (props.loading === true) {
            paymentsData = (
                <tr className="table-loader">
                    <td>
                        <Loader />
                    </td>
                    <td className="recepient_date_column">
                        <Loader />
                    </td>
                    <td>
                        <Loader />
                    </td>
                    <td>
                        <Loader />
                    </td>
                </tr>
            );
        } else {
            // console.log("loading", props.loading);
            paymentsData = (
                <tr className="table-loader">
                    <td>No Data.</td>
                    <td>No Data.</td>
                    <td>No Data.</td>
                    <td>No Data.</td>
                </tr>
            );
        }

        return paymentsData;
    }

    return (
        <div>
            <div style={{ minHeight: "45vh" }}>
                <table className="table table-striped table-bordered app-table">
                    <thead>
                        <tr>
                            <th>Amount</th>
                            <th>Receipt Date</th>
                            <th>Payment Method</th>
                            <th>Receipts Link</th>
                        </tr>
                    </thead>
                    <tbody>{displayTableData()}</tbody>
                </table>
            </div>

            <Paginate
                pageCount={props.payments.last_page}
                currentPage={props.payments.current_page}
                handler={props.handler}
                nextUrl={props.payments.next_page_url}
                prevUrl={props.payments.prev_page_url}
            />
        </div>
    );
};

export default MyDonationPayments;
